import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

import {
  AreaChart,
  Area,
  //BarChart,
  LineChart,
  //Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

import {
  getChargeJour, getAllAgencies,
  getUser, getUserAgency
} from '../API';

import { useTranslation } from "react-i18next";

function ChargeJour() {

  const [t] = useTranslation('common');

  const [user, setUser] = useState('');
  const [agency, setAgency] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [service, setService] = useState("SE");

  const [chargeArray, setChargeArray] = useState([]);

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setUserAgency(response)
      })
  }, []);


  useEffect(() => {

    getChargeJour(agency, service)
      .then(response => {
        setChargeArray(response);
      });

  }, [refreshKey]);


  async function handleServiceClick(e) {
    if (e.target.innerHTML == t('dailyotp.week')) {
      setService('SE')
    } else if (e.target.innerHTML == t('dailyotp.sat')) {
      setService('SA')
    } else {
      setService('DI')
    }
    setRefreshKey(oldKey => oldKey + 1);
  }

  async function handleAgencySelect(e) {
    setAgency(e.target.value);
    setRefreshKey(oldKey => oldKey + 1);
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active, payload) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            Date: {payload[0] ? payload[0].payload.date : ''} <br />
            {t('dailyocc.occ')} {payload[0] ? payload[0].payload.occupancyaverage : ''} <br />
          </p>
        </div>
      );
    }
    return null;
  }


  return (
    chargeArray ?
      <>
        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm"></div>
          <h1 id="page-title" className="display-5">{t('dailyocc.title')}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="row justify-content-center pt-3">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-center">

              <div className="me-1 border rounded ps-2 pe-2 pt-4 pb-4" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center align-items-center">
                  {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="col-lg-2">
                    <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>Opérateur</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div> : ''}

                  <h4>{t('datatable.days')}</h4>
                  <div className="col text-center pb-2">
                    <div type="button" className={service == "SE" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.week')}</div>
                    <div type="button" className={service == "SA" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sat')}</div>
                    <div type="button" className={service == "DI" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sun')}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center pt-3 pb-4">
            <div className="col-lg col-sm-12 pt-3">
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-12 text-center">
                    <ResponsiveContainer width="100%" height={400}>
                      <AreaChart
                        width={500}
                        height={50}
                        data={chargeArray}
                        margin={{
                          top: 10,
                          right: 30,
                          left: 30,
                          bottom: 0,
                        }}
                      >
                        <XAxis dataKey="date" angle={-90} dx={-4} textAnchor="end" height={100} />
                        <YAxis type="number" />
                        <Tooltip
                          filterNull={false}
                          content={<CustomTooltip />} />
                        {/* <Legend /> */}
                        <Area type="monotone" name="charge" dataKey="occupancyaverage" stackId="1" stroke="black" fill="#79508f" isAnimationActive={false}
                          dot={{ stroke: 'black', strokeWidth: 1, r: 2, strokeDasharray: '' }} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </> :
      <>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </>
  )
}

export default ChargeJour